import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Badge } from 'react-bootstrap';

import { type Conflict } from '@editor2/types/conflict';
import { type RootState } from '@editor2/reducers/root';
import IncomingChangesDivider from '../common/IncomingChangesDivider';
import { getEntityName } from '../helpers';
import { itemMoveChangeBlock } from '../styles';
import CurrentChangesDivider from '../common/CurrentChangesDivider';

interface Props {
	conflict: Conflict;
	courseId: number;
}

const ItemMoveView: FC<Props> = (props) => {
	const { conflict, courseId } = props;

	const { initial, current, incoming, entityId, entityType } = conflict;

	const courseState = useSelector((state: RootState) => state.courses[courseId]);

	const itemName = getEntityName(entityId, entityType, courseState);
	const initialParentName = getEntityName(
		(initial as any).family_id,
		(initial as any).type,
		courseState
	);
	const currentParentName = getEntityName(
		(current as any).family_id,
		(current as any).type,
		courseState
	);
	const incomingParentName = getEntityName(
		(incoming as any).family_id,
		(incoming as any).type,
		courseState
	);

	return (
		<div>
			<Alert variant="warning">
				Another editor already moved <strong>{itemName}</strong> to{' '}
				<strong>{incomingParentName}</strong>. You may keep either your change or their change.
			</Alert>

			<CurrentChangesDivider conflict={conflict} courseId={courseId} showButton={true} />
			<div className={itemMoveChangeBlock}>
				<strong>{itemName}</strong> moved from <Badge variant="danger">{incomingParentName}</Badge>{' '}
				to <Badge variant="primary">{currentParentName}</Badge>
			</div>

			<IncomingChangesDivider conflict={conflict} courseId={courseId} showButton={true} />
			<div className={itemMoveChangeBlock}>
				<strong>{itemName}</strong> moved from <Badge variant="danger">{initialParentName}</Badge>{' '}
				to <Badge variant="primary">{incomingParentName}</Badge>
			</div>
		</div>
	);
};

export default ItemMoveView;
